import { gql } from "@apollo/client";

export const CREATE_CREDIT_NOTE = gql`
  mutation createCreditNote($creditNote: CreateCreditNoteInput!) {
    createCreditNote(creditNote: $creditNote) {
      id
      creditNoteRef
      createdAt
      invoice {
        id
        invoiceRef
      }
      totalAmount
      refundedAmount
      availableAmount
      creditNoteItems {
        type
        description
        originalPrice
        quantity
        unitPrice
        totalAmount
        duration
      }
      refunds {
        mode
        amount
        status
        id
        refundRef
        currency
        paymentIntent
      }
      allocations {
        amount
        allocatedAt
        invoice {
          invoiceRef
        }
      }
    }
  }
`;